import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { CreerService } from '../../../../services/creeer';
import { useParams } from 'react-router-dom';
import { linkify } from '../../../../helpers';

const WebPageFail = () => {
  const [responseText, setResponseText] = useState('');
  const { id } = useParams();

  const getTrainingResponse = async (trainingId) => {
    const response = await CreerService.getWebAnswerTraining(trainingId);
    const text = response.data.data.incorrectResponse;
    setResponseText(text);
  };

  useEffect(() => {
    getTrainingResponse(id);
  }, []);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
      }}
    >
      <FontAwesomeIcon icon={faCircleXmark} size="4x" color="#d32f2f" />
      <pre
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '24px',
          marginTop: '20px',
          whiteSpace: 'pre-wrap',
        }}
        dangerouslySetInnerHTML={{ __html: linkify(responseText) }}
      />
    </Box>
  );
};

export default WebPageFail;
